<template>
  <div>
      <div v-if="!$apollo.loading" class="uk-section uk-background-darkest page-header">
          <div class="uk-position-large uk-margin-remove-top">
              <div class="uk-grid" uk-grid>
                  <div class="uk-light uk-width-1-3@l uk-width-2-5@m uk-width-1-1@xs">
                      <div class="uk-margin-large-top">
                          <router-link :to="project.link" class="text-blue"><label>{{project.title}}</label></router-link>
                          <h1 class="uk-margin-large-bottom">Storytellers</h1>
                          <!-- <p class="uk-text-lead">{{project.summary}}</p> -->
                          <!-- <h3 class="uk-margin-medium-bottom"><em>{{project.Quote}}</em></h3> -->

                          <router-link to="hero" class="uk-button uk-button-primary theme-button"  v-if="project.heroText">Meet the Hero</router-link>
                      </div>
                  </div>
                  <div class="uk-light uk-width-2-3@l uk-width-3-5@m uk-width-1-1@xs">
                    <div v-html="project.storytellersEmbedCode" v-if="!!project.storytellersEmbedCode" class="flex-video widescreen uk-margin-top"></div>
                    <img :src="project.storytellersImage.medium" v-if="!!project.storytellersImage.medium" />
                  </div>
              </div>
          </div>
      </div>


    <div class="uk-section uk-section-medium uk-background-white">
        <div class="uk-container uk-container-small">
            <h1><b>Meet the Storytellers:</b> {{project.title}}</h1>
            <div v-html="project.storytellersText"></div>
        </div>
    </div>

  </div>
</template>

<script>
export default {
    inject: ['theme'],
    props: ['project'],
    data() {
        return {
        }
    },
    components: {
    },
    computed: {
        bgImage() {
            return (!!this.project.HeroImage && !!this.project.heroImage.Large) ? this.project.heroImage.Large : (!!this.project.Image ? this.project.image.large : "");
        }
    }
}
</script>
